import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import htmlSerializer from '../../utils/htmlSerializer';
const CustomPrescreen = ({ content, onClose, onURLButtonClick, buttonColor, }) => {
    return (_jsx(React.Fragment, { children: content.map((content, index) => htmlSerializer({
            content,
            key: `customHTML-${index}`,
            onClose,
            onURLButtonClick,
            buttonColor,
        })) }));
};
export default CustomPrescreen;
//# sourceMappingURL=CustomPrescreen.js.map